import { ButtonGroup, ControlGroup, Position } from "@blueprintjs/core"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomButton from "components/Atoms/CustomButton"
import AppToaster from "utils/AppToaster"
import {
  OPEN_ROUTE_PREVIEW,
  SORT_SELECTED_ORDERS,
  useSelectedOrdersArray,
  CLOSE_ROUTE_PREVIEW,
} from "store/dispatch.redux"
import ConfirmPanel from "./ConfirmPanel"
import DepotSelector from "./DepotSelector"
import OrderSerial from "./OrderSerial"
import VehicleSelector from "./VehicleSelector"

const TripStepPanel = ({ closePanel, openPanel }) => {
  const selectedOrders = useSelectedOrdersArray()
  const source = useSelector(
    (state: any) => state.dispatch.sourceDepot?.location
  )
  const dest = useSelector(
    (state: any) => state.dispatch.destinationDepot?.location
  )
  const orderSequenceCustomized = useSelector(
    (state: any) => state.dispatch?.orderSequenceCustomized
  )
  const serialItems = selectedOrders.map((_, idx) => ({
    id: idx,
    name: idx + 1,
  }))
  const dispatch = useDispatch()
  return (
    <>
      <VehicleSelector
        onBackClick={item => {
          dispatch({
            type: CLOSE_ROUTE_PREVIEW,
          })
          closePanel(item)
        }}
      />
      <div className="p-3">
        <ControlGroup fill>
          <DepotSelector fill label="Source Depot" path="sourceDepot" />
          <DepotSelector
            fill
            label="Destination Depot"
            path="destinationDepot"
            popoverClassName="vt-depot-selector"
            popoverProps={{
              position: Position.TOP,
            }}
          />
        </ControlGroup>
      </div>
      <section className="vt-trip-panel">
        {selectedOrders?.map((o, idx) => {
          return (
            <OrderSerial
              key={o?.id}
              order={o}
              items={serialItems}
              index={idx}
            />
          )
        })}
      </section>
      <div className="p-3 vt-dispatch-panel-button">
        <ButtonGroup fill>
          <CustomButton
            onClick={e => {
              if (!source || !dest) {
                AppToaster.show({
                  message: "Please enter valid source and destination depots",
                  intent: "danger",
                  icon: "cross",
                })
                return
              }

              const directionService =
                new window.google.maps.DirectionsService()
              directionService.route(
                {
                  origin: {
                    lat: source?.latitude,
                    lng: source?.longitude,
                  },
                  optimizeWaypoints: orderSequenceCustomized ? false : true,
                  destination: {
                    lat: dest?.latitude,
                    lng: dest?.longitude,
                  },
                  travelMode: google.maps.TravelMode.DRIVING,
                  waypoints: selectedOrders.map(o => {
                    const ship = o?.shippingAddress
                    return {
                      stopover: true,
                      location: {
                        lat: ship?.latitude,
                        lng: ship?.longitude,
                      },
                    }
                  }) as any,
                },
                (res: any) => {
                  if (res.status === "OK") {
                    const route = res?.routes[0]
                    const sortedMap = new Map()
                    if (route) {
                      route.waypoint_order.forEach(wp => {
                        return sortedMap.set(
                          selectedOrders?.[wp]?.id,
                          selectedOrders?.[wp]
                        )
                      })

                      dispatch({
                        type: OPEN_ROUTE_PREVIEW,
                        payload: res?.routes[0].overview_path,
                      })
                      dispatch({
                        type: SORT_SELECTED_ORDERS,
                        payload: sortedMap,
                      })
                    }
                  } else {
                    AppToaster.show({
                      intent: "danger",
                      icon: "cross",
                      message:
                        "Unable to sort the route points, Please try again",
                    })
                  }
                }
              )
            }}
            icon="path-search"
            big
            text="Preview Route"
          />
          <CustomButton
            className="ml-3"
            big
            intent="primary"
            icon="tick"
            text="Confirm"
            onClick={() => {
              openPanel({
                component: ConfirmPanel,
              })
            }}
          />
        </ButtonGroup>
      </div>
    </>
  )
}

export default TripStepPanel
